import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ReadOnlyType, UomSetProps } from 'app/area/codetable/item/types';
import { createUomSetFieldId } from 'app/area/codetable/item/codetable-item-helpers';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const SubstanceSetUom = (props: UomSetProps) => {

  const { substanceUomSetValue: { uomType, uom, uomSet: { value: currentUomSetValue = undefined } = {} },
    breadcrumbs, codeItem: { substanceUomSet } = {}, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig } = props;

  const fieldId = createUomSetFieldId(ScreenPicker.uom, currentUomSetValue);
  const codetableId = codetableOptionsIds[ScreenPicker.uom];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(fieldId);
    updateByKey(ScreenPicker.substanceUomSet,
      substanceUomSet.map(item => item.uomSet.value === (currentUomSetValue)
        ? { ...item, [ScreenPicker.uom]: value }
        : item));
  };

  const categoryId = uomType &&
    isDefinedIncludingZero(uomType.value) ? uomType.value : undefined;

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams, displayNotSelected: false,
      categoryId
    });
  };

  const codeOptions = codetableOptions?.[fieldId]?.codes ?? [] as CodeComplexValue<number>[];
  const uomValidation = !!validation && !!validation[fieldId] ? validation[fieldId] : undefined;
  const finalValidation = { ...uomValidation, ...getDisabledValidation(uom?.disabled, translation.selected_value_disabled) };
  const readOnly = (readOnlyConfig && readOnlyConfig[ReadOnlyType.all]);

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  return <CodeSinglePicker
    id={fieldId}
    label={translation.default_uom}
    valueItem={uom}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly || !uomType}
    options={codeOptions}
    fetchingOptions={!!codetableOptions && codetableOptions[fieldId] && codetableOptions[fieldId].fetching}

    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
